import { IMapOptions, IMapOptionsPayload } from '../map.types';
import { mapPreRenderStyles } from './mapPreRenderStyles';

const MAP_DIV_ID = 'mapsToRender';

export const defaultMapOptions: IMapOptions = {
  center: { lat: -23.550421, lng: -46.633468 },
  zoom: 12,
  // mapId: 'google-map',
  disableDefaultUI: true,
  streetViewControl: true,
  zoomControl: true,
  // clickableIcons: false,

  styles: mapPreRenderStyles,
};

export const defaultMapOptionsPayload: IMapOptionsPayload = {
  mapsDivId: MAP_DIV_ID,
  mapOptions: defaultMapOptions,
};
